<template>
  <div>
    <div slot="default" style="width:100%;">
      <div :class="title_component">
        <!-- possibility to replay only video with pointer_event:auto, default is "pointer_event:none" -->
        <video
          :style="`pointer-events: ${pointer_event}`"
          playsinline
          webkit-playsinline
          ref="myVideo"
          :class="`video-js ${this.attributes.mode}`"
          data-setup="{}"
        ></video>
      </div>
      <div v-if="$store.getters.isStarted && this.config.attributes.text">
        <Message
          class="h5 m-1"
          :msg="`${this.config.attributes.text}`"
        ></Message>
      </div>
    </div>

    <ruler-widget
      v-if="config.attributes.ruler"
      :sceneWidth="45"
      :sceneHeight="30"
      :refunity="unity"
    ></ruler-widget>
  </div>
</template>
<script src="/node_modules/videojs-vimeo-v2/src/Vimeo.js"></script>

<script>
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import videojs from "video.js";
import videojsPlaylist from "videojs-playlist/dist/videojs-playlist.js";
import Bus from "../services/bus.js";
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import RulerWidget from "ireal-vue/widgets/RulerWidget.vue";
import Message from "ireal-vue/components/MessageComponent.vue";

export default {
  name: "video-multiple-component",
  mixins: [dataComponentMixin],
  components: { CollapsibleWidget, RulerWidget, Message },
  data() {
    return {
      // VideoJS player
      player: null,
      // URL of the video
      source: "",
      tab_sequency: [],
      pausetime: 0,
      datatime: "",
      poster: "",
      currentime: 0,
      navigateur: navigator.platform,
      stepVideo: null,
      unity: "cm"
    };
  },
  async mounted() {
    // on utilise "ref" au lieu de "id" afin d'éviter les conflits d'id unique alors que l'on va générer différentes videos ( principe vu dans la doc)
    // ressource: https://docs.videojs.com/tutorial-vue.html
    // Initialize playerc
    if (this.config.attributes.ruler) {
      setTimeout(() => {
        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent), 2000;
      });
    }
    this.player = videojs(this.$refs.myVideo, {
      controls: true,
      fluid: true
    });
    // Sets initial poster
    this.setPoster();

    // Change poster on value changes
    Bus.$on("value-changed", async payload => {
      if (payload.param == this.model_poster) {
        this.setPoster(payload.value);
      }
    });
    // catch the program "ireal-start" ( send by the mutation store )
    Bus.$on("ireal-start", async () => {
      var result = [];
      var total_duration = 0;
      for (var flux_video in this.config.elements) {
        this.source = await this.getObservationVideos(
          this.config.elements[flux_video].attributes.name
        );

        this.source_playlist = this.source;
        this.$store.commit("test", this.source.parameters);
        this.datatime = {
          duration: this.source_playlist.duration,
          start: this.source_playlist.start,
          end: this.source_playlist.start + this.source_playlist.duration
        };
        total_duration = total_duration + this.source.duration;

        result.push({
          sources: [
            {
              type: "video/mp4",
              src: this.source_playlist.video_path_sd,
              start: this.source_playlist.start,
              duration: this.source_playlist.duration,
              end: this.source_playlist.start + this.source_playlist.duration
            }
          ]
        });
        this.tab_sequency.push([
          total_duration,
          total_duration + this.datatime.duration
        ]);
        // this.player.play();
        // this.player.currentTime(this.datatime.start);
        // this.$store.commit("setDuration", this.datatime.duration * 1000);
      }
      this.$store.commit("setDuration", total_duration * 1000);
      var final_result = [];
      for (var key in result) {
        final_result.push(result[key]);
      }

      this.player.playlist(final_result);
      this.player.playlist.autoadvance(0);
      this.player.currentTime(this.player.playlist()[0].sources[0].start);
      this.player.play();
    });

    Bus.$on("ireal-stop", async () => {
      this.player.reset();
      window.setTimeout(() => this.player.poster(this.poster), 1);
      // voir aussi Vue.nextTick( [callback, context] ) au lieu de setTimeout()
    });

    Bus.$on("ireal-pause", async () => {
      //var myPlayer = videojs(this.$refs.myVideo);
      this.player.pause();
    });
    Bus.$on("ireal-un-pause", async () => {
      //var myPlayer = videojs(this.$refs.myVideo);
      this.player.play();
    });
    Bus.$on("ireal-speed", async speed => {
      //var myPlayer = videojs(this.$refs.myVideo);
      this.player.playbackRate(speed);
    });
    Bus.$on("ireal-back", async speed => {
      //var myPlayer = videojs(this.$refs.myVideo);
      for (var index in this.tab_sequency) {
        var progress = this.$store.getters.progress / 1000;
        var min = this.tab_sequency[index][0];
        var max = this.tab_sequency[index][1];
        if (this.between(progress, min, max)) {
          this.player.playlist.currentItem(parseInt(index));

          this.player.on("loadedmetadata", () => {
            this.player.currentTime(
              (this.$store.getters.progress - 2000) / 1000
            );
          });
          this.player.currentTime(10);
          this.player.play();

          break;
        }
      }
    });
    Bus.$on("ireal-resync", async progress => {
      //var myPlayer = videojs(this.$refs.myVideo);
      var time = this.datatime.start + progress / 1000;
      if (time < this.datatime.start) time = this.datatime.start;
      if (time > this.datatime.end) {
        time = this.datatime.end;
        this.player.currentTime(time);
      } else {
        this.player.currentTime(time);
        this.player.play();
      }
    });
    Bus.$on("ireal-tick", async () => {
      var item_playing = this.player.playlist.currentItem();
      if (
        this.player.currentTime() >
        this.player.playlist()[item_playing].sources[0].end
      ) {
        this.player.playlist.next();
        this.player.play();
      }
    });
  },
  methods: {
    prepare() {},
    setPoster(value) {
      value = value ? `_${value}` : "";
      this.poster = `${this.IREALCONFIG.static_ressources}/${this.$store.getters.experienceIdentifier}_${this.flux_identifier}${value}_poster.jpg`;
      this.player.poster(this.poster);
    },
    between(progress, min, max) {
      return progress >= min && progress <= max;
    }
  }
};
</script>
<style scoped>
.portrait {
  min-height: 50vh !important;
}
</style>
<style src="video.js/dist/video-js.css"></style>
